import React from 'react';
import styled from '@emotion/styled';
import { compact } from 'utility/compact';

const Frame = styled.div({
    display: 'grid',
    height: '100%',
    padding: '3px',
    gridTemplateRows: '1fr 2fr',
    gridTemplateColumns: '1fr 2fr 1fr',
    gap: '3px',
    backgroundColor: '#E9EEF4',
    boxSizing: 'border-box',
    ['> *']: {
        overflow: 'hidden',
    },
});

export type VehicleMonitorProps = {
    className?: string;
    status?: JSX.Element;
    front?: JSX.Element;
    left?: JSX.Element;
    right?: JSX.Element;
    back?: JSX.Element;
    panel?: JSX.Element;
}

export const VehicleMonitor = (props: VehicleMonitorProps) => {
    const { status, front, left, right, back, panel } = props;

    const channels = compact([status, back, panel, left, front, right]);
    if (channels.length > 1) {
        return (
            <Frame>
                {status || <div />}
                {back || <div />}
                {panel || <div />}
                {left || <div />}
                {front || <div />}
                {right || <div />}
            </Frame>
        );
    } else if (status) {
        return (
            <Frame>
                {status}
                <div>No Video Channels</div>
            </Frame>
        );
    } else {
        return (
            <div>No Channels</div>
        );
    }
};
